import { graphql, navigate } from 'gatsby';
import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { LayoutContext } from '../components/organisms/layoutProvider';
import { media } from '../utils/media-queries';
import SEO from '../components/organisms/seo';
import RichText from '../components/atoms/richtext';

const PrivacyPage = ({ data }) => {
  const { language } = useContext(LayoutContext);
  const raw = language === 'en' ? '_rawEn' : '_rawDe';

  useEffect(() => {
    navigate(language === 'en' ? '/privacy' : '/de/privacy', { replace: true });
  }, [language]);

  const { title, content } = data.privacy.nodes[0];

  return (
    <>
      <SEO siteTitle={title[language] || title.en} />
      <StyledPrivacy className="spacing-inner">
        <p className="title">{title[language] || title.en}</p>
        <div className="content">
          <RichText blocks={content[raw] || content._rawEn} />
        </div>
      </StyledPrivacy>
    </>
  );
};

const StyledPrivacy = styled.section`
  min-height: 100vh;
  margin-top: var(--v-spacing-S);
  font-family: var(--font-1);

  .title {
    padding-bottom: var(--v-spacing-S);
  }

  .content {
    p {
      padding-bottom: var(--v-spacing-S);
    }
  }

  @media ${media.L} {
    .content {
      width: 33%;
    }
  }
`;

export const query = graphql`
  query Privacy {
    privacy: allSanityPrivacy {
      nodes {
        title {
          de
          en
        }
        content {
          _rawDe
          _rawEn
        }
      }
    }
  }
`;

PrivacyPage.propTypes = {
  data: PropTypes.object,
};

export default PrivacyPage;
